<template>
    <div class="container">
        <div class="col-md-12">
            <h2>{{ labels.title }}</h2>
        </div>

        <b-container>
            <!-- Filtros principales - Centrados -->
            <b-row class="mb-4 justify-content-center">
                <!-- Reporte -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.reporte }}</b></label>
                    <select v-model="selReporte" class="form-control form-control-lg">
                        <option value="">{{ labels.select }}</option>
                        <option v-for="(item, idx) in reportes" :key="'codigo-'+idx" :value="item.codigo">
                            {{item.codigo}}-{{item.nombre}}
                        </option>
                    </select>
                </b-col>

                <!-- Vigencia -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.validity }}</b></label>
                    <select v-model="selVigencia" class="form-control form-control-lg">
                        <option value="">{{ labels.select }}</option>
                        <option v-for="vigencia in listVigencia" :key="vigencia.vigencia">
                            {{ vigencia.vigencia }}
                        </option>
                    </select>
                </b-col>
            </b-row>

            <!-- Botón Consultar -->
            <b-row class="mb-4 justify-content-center">
                <b-col md="12" class="text-center">
                    <b-button @click="consultaRedefinicionFilas" id="consult-btn" size="lg" variant="outline-primary">
                        <b-icon icon="search" class="me-2"></b-icon>
                        {{ labels.consultar }}
                    </b-button>
                </b-col>
            </b-row>

            <!-- Resultados de la consulta -->
            <div v-if="showTblRedFilas">
                <b-row class="mb-4 align-items-end">
                    <!-- Buscador -->
                    <b-col md="4">
                        <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">{{ labels.search
                            }}</label>
                        <b-form-input v-model="searchRedFila" @input="searchOnTableRedFila" class="form-control"
                            :placeholder="labels.search + '...'">
                        </b-form-input>
                    </b-col>

                    <b-col md="2" class="d-flex align-items-end">
                        <b-button @click="borraCriterio" variant="outline-secondary" class="w-100"
                            style="height: 38px;">
                            <b-icon icon="arrow-counterclockwise" class="me-2"></b-icon>
                            {{ labels.clear }}
                        </b-button>
                    </b-col>

                    <!-- Botón Crear -->
                    <b-col md="2" class="d-flex align-items-end">
                        <b-button @click="creaRedFila()" variant="primary" class="w-100" style="height: 38px;"
                            :disabled="!selReporte || !selVigencia || isVigenciaBloqueada">
                            <b-icon icon="plus" class="me-2"></b-icon>
                            {{ labels.create }}
                        </b-button>
                    </b-col>

                    <!-- Selector de registros -->
                    <b-col md="4" class="d-flex align-items-end">
                        <b-form-select v-model="itemLimit" :options="limitOptions" size="md" style="width: 100%;"
                            @change="resetVisibleItems">
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Contador -->
                <b-row class="mb-3">
                    <b-col md="12">
                        <div class="text-muted text-center">
                            {{ labels.showing }} <strong>{{ visibleItems.length }}</strong> {{ labels.of }}
                            <strong>{{ listRedefinicionFila.length }}</strong> {{ labels.records }}
                        </div>
                    </b-col>
                </b-row>

                <!-- Tabla -->
                <b-row>
                    <b-col md="12">
                        <div class="table-responsive custom-scroll-container" ref="scrollContainer">
                            <table class="table table-hover table-bordered">
                                <thead style="background-color: #4a90e2;">
                                    <tr>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{ labels.niif }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{ labels.description }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{ labels.firstLevel }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{ labels.secondLevel }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{ labels.formulacion }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in visibleItems" :key="item.id" @click="editRedFila(item.id)"
                                        :class="{ 'clickable-row': !isVigenciaBloqueada }">
                                        <td class="text-center"><strong class="text-dark">{{ item.niif }}</strong></td>
                                        <td class="text-left">{{ item.descripcion }}</td>
                                        <td class="text-left">{{ namePrimerNivel(item.primer_nivel) }}</td>
                                        <td class="text-left">{{ nameSegundoNivel(item.primer_nivel,item.segundo_nivel)
                                            }}</td>
                                        <td class="text-left" :title="item.formulacion">
                                            {{ truncateFormulation(item.formulacion) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <!-- Mensaje cuando no hay datos -->
            <div v-else-if="fgl_consulta && listRedefinicionFila.length === 0" class="mt-4 text-center">
                <div class="h4 text-muted">
                    <b-icon icon="inbox" class="me-2"></b-icon>
                    {{ labels.noData }}
                </div>
            </div>

            <!-- Mensaje cuando no se ha consultado -->
            <div v-else-if="!fgl_consulta" class="mt-4 text-center">
                <div class="h4 text-muted">
                    <b-icon icon="search" class="me-2"></b-icon>
                    {{ labels.noConsult }}
                </div>
            </div>
        </b-container>

        <div v-if="!isLoading"></div>
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
        </div>

        <!-- PASAMOS selVigencia y selReporte a los modales -->
        <CreaRedefinicionFila
            :modCreaRedFila="modCreaRedFila"
            :vigenciaSelected="selVigencia"
            :codReporte="selReporte"
            @cierraModal="modCreaRedFila = false"
            @reload="consultaRedefinicionFilas"
        />

        <EditaRedefinicionFila
            :modEditaRedFila="modEditaRedFila"
            :dataRedFila="itemRedFila"
            :vigenciaSelected="selVigencia"
            :codReporte="selReporte"
            @cierraModal="modEditaRedFila = false"
            @reload="consultaRedefinicionFilas"
        />

        <InacticaItem :InactivaItem="deletFila" @confirmDelete="confirmDel" @cierraModal="closeModal" />
    </div>
</template>

<script>
import RedefinicionFila from '../../../services/RedefinicionFila';
import PrimerNivel from '../../../services/PrimerNivel';
import SegundoNivel from '../../../services/SegundoNivel';
import CreaRedefinicionFila from './CreaRedefinicionFila.vue';
import EditaRedefinicionFila from './EditaRedefinicionFila.vue';
import PlanConsolidacion from '../../../services/PlanConsolidacion';
import TipoReporte from  '../../../services/TipoReporte';
import InacticaItem from '../../utils/InacticaItem.vue'

const toLower = (text) => {
    return text.toString().toLowerCase();
};

const searchByRedFila = (items, term) => {
    if (term) {
        const termLower = toLower(term);
        return items.filter((item) => {
            if (item.niif && toLower(item.niif.toString()).includes(termLower)) return true;
            if (item.descripcion && toLower(item.descripcion).includes(termLower)) return true;
            return false;
        });
    }
    return items;
};

export default {
    name: "RedefinicionFilas",
    components:{
        CreaRedefinicionFila,
        EditaRedefinicionFila,
        InacticaItem
    },
    data: () => ({
        listVigencia: [],
        selVigencia: "",
        selReporte: "",

        listRedefinicionFila: [],
        listRedefinicionFilaOrigen: [],
        firstLevSel: "",
        listFirstLev: [],
        listSecondLev: [],

        modCreaRedFila: false,
        modEditaRedFila: false,

        itemRedFila: [],

        reportes: [],
        showTblRedFilas: false,
        deletFila: false,
        rowId: '',
        fgl_consulta: false,
        searchRedFila: null,
        isLoading: false,
        itemLimit: 100,
        visibleItems: [],
        limitOptions: [
            { value: 100, text: '100 registros' },
            { value: 200, text: '200 registros' },
            { value: 500, text: '500 registros' },
            { value: 0, text: 'Mostrar todo' }
        ]
    }),
    computed:{
        isVigenciaBloqueada() {
            return this.selVigencia ? !this.$store.getters.isPeriodoEnabled(this.selVigencia) : false
        },
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : "Redefinición de filas",
                    save : "Guardar",
                    firstLevel : "Primer Nivel",
                    secondLevel : "Segundo Nivel",
                    formulacion : "Formulación",
                    niif : "NIIF",
                    description : "Descripción",
                    editar : "Editar",
                    eliminar : "Eliminar",
                    validity : "Vigencia:",
                    reporte : "Reporte:",
                    select : "Seleccione...",
                    consultar: "Consultar",
                    search: "Buscar",
                    create: "Crear",
                    clear: "Limpiar",
                    showing: "Mostrando",
                    of: "de",
                    records: "registros",
                    noData: "No hay datos",
                    noConsult: "Realice una consulta para ver los datos"
                }
            }else{
                return {
                    title : "Row redefinition",
                    save : "Save",
                    firstLevel : "First Level",
                    secondLevel : "Second Level",
                    formulacion : "Formulation",
                    niif : "NIIF",
                    description : "Description",
                    editar : "Edit",
                    eliminar : "Delete",
                    validity : "Validity",
                    reporte : "Report",
                    select : "Select...",
                    consultar: "Consult",
                    search: "Search",
                    create: "Create",
                    clear: "Clear",
                    showing: "Showing",
                    of: "of",
                    records: "records",
                    noData: "No data",
                    noConsult: "Perform a query to see the data"
                }
            }
        }
    },
    methods:{
        consultaRedefinicionFilas() {
            if (this.selVigencia && this.selReporte) {
                this.isLoading = true;
                this.fgl_consulta = true;
                
                Promise.all([
                    PrimerNivel.getFirstLevelByReporte(this.selReporte),
                    SegundoNivel.getAllLevelSecond(this.selReporte),
                    RedefinicionFila.getAllRedefinicionFilas(this.selReporte)
                ])
                .then(([firstLevelRes, secondLevelRes, redefinicionRes]) => {
                    this.listFirstLev = firstLevelRes.data.firstLevByReport || [];
                    this.listSecondLev = secondLevelRes.data.segundoNivel || [];
                    this.listRedefinicionFila = redefinicionRes.data.redefinicionFila || [];
                    this.listRedefinicionFilaOrigen = [...this.listRedefinicionFila];
                    this.showTblRedFilas = true;
                    this.resetVisibleItems();
                })
                .catch((err) => {
                    console.log(err);
                    this.$toast.error('Error al consultar las redefiniciones de filas');
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.$toast.error('Debe seleccionar reporte y vigencia');
            }
        },

        truncateFormulation(formulation) {
            if (!formulation) return '';
            if (formulation.length > 50) {
                const niifMatch = formulation.match(/^(Niif\([^)]+\))/i);
                if (niifMatch) {
                    const niifPart = niifMatch[1];
                    if (niifPart.length > 50) {
                        const numbersMatch = niifPart.match(/Niif\(([^)]+)\)/i);
                        if (numbersMatch) {
                            const numbers = numbersMatch[1].split(',');
                            if (numbers.length > 8) {
                                const truncatedNumbers = [
                                    ...numbers.slice(0, 5),
                                    '...',
                                    ...numbers.slice(-3)
                                ].join(',');
                                return `Niif(${truncatedNumbers})`;
                            }
                        }
                    }
                    return niifPart;
                }
                return formulation.substring(0, 50) + '...';
            }
            return formulation;
        },

        closeModal(val){
            this.modCreaRedFila = val;
            this.modEditaRedFila = val;
            this.deletFila = val;
        },

        namePrimerNivel(idFirstLev){
            let name = this.listFirstLev.find((firstLev) => firstLev.primer_nivel == idFirstLev)
            return name == undefined ? idFirstLev : name.descripcion
        },

        nameSegundoNivel(idFirstLev,idSecondLev){
            let name = this.listSecondLev.find((secondLev) => secondLev.primer_nivel == idFirstLev && secondLev.segundo_nivel == idSecondLev)
            return name != undefined ? name.descripcion : idSecondLev
        },

        creaRedFila(){
            if (this.isVigenciaBloqueada) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.');
                return;
            }
            if (this.selVigencia && this.selReporte) {
                this.modCreaRedFila = true;
            } else {
                this.$toast.error('Debe seleccionar reporte y vigencia primero');
            }
        },

        editRedFila(id) {
            if (this.isVigenciaBloqueada) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.');
                return;
            }
            RedefinicionFila.getAllFilaById(id)
                .then((res) => {
                    this.itemRedFila = res.data.redefinicionFilaById || [];

                    // Normalizar listaNiif si viene como strings
                    if (this.itemRedFila[0] && this.itemRedFila[0].listaNiif && this.itemRedFila[0].listaNiif.length > 0) {
                        this.itemRedFila[0].listaNiif = this.itemRedFila[0].listaNiif.map(n => parseInt(n));
                    }

                    // Si no viene listaNiif, intentar extraer de formulacion
                    if (this.itemRedFila[0] && (!this.itemRedFila[0].listaNiif || this.itemRedFila[0].listaNiif.length === 0) && this.itemRedFila[0].formulacion) {
                        this.itemRedFila[0].listaNiif = this.extractNiifCodesFromFormulation(this.itemRedFila[0].formulacion);
                    }

                    this.modEditaRedFila = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.$toast.error('Error al cargar los datos de la fila');
                })
        },

        extractNiifCodesFromFormulation(formulation) {
            if (!formulation) return [];
            const niifMatch = formulation.match(/Niif\(([^)]+)\)/i);
            if (niifMatch) {
                return niifMatch[1].split(',').map(num => parseInt(num.trim())).filter(num => !isNaN(num));
            }
            return formulation.replace(/[+-]/g, ',').split(',').map(n => parseInt(n.trim())).filter(n => !isNaN(n));
        },

        deleteRedFila(id){
            this.rowId = id
            this.deletFila = true
        },
        confirmDel(){
            RedefinicionFila.deleteRedefinicionFila(this.rowId)
            .then((res) => {
                this.$toast.success(res.data.message)
                this.consultaRedefinicionFilas(); // Recargar datos
            })
            .catch((err) => {
                console.log(err)
                this.$toast.error('Error al eliminar la redefinición de fila');
            })
        },

        borraCriterio() {
            this.searchRedFila = ''
            this.listRedefinicionFila = this.listRedefinicionFilaOrigen || this.listRedefinicionFila
            this.resetVisibleItems()
        },

        resetVisibleItems() {
            if (this.itemLimit === 0) {
                this.visibleItems = [...this.listRedefinicionFila];
            } else {
                this.visibleItems = this.listRedefinicionFila.slice(0, this.itemLimit);
            }
        },

        searchOnTableRedFila() {
            if (this.searchRedFila) {
                this.listRedefinicionFila = searchByRedFila(this.listRedefinicionFilaOrigen, this.searchRedFila);
            } else {
                this.listRedefinicionFila = [...this.listRedefinicionFilaOrigen];
            }
            this.resetVisibleItems();
        }
    },
    watch: {
        selVigencia() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.');
            }
        }
    },
    mounted(){
        TipoReporte.getAllTipoReporte()
        .then((res) => {
            this.reportes = res.data.typeReport || [];
        })
        .catch((err) => console.log(err))
        .finally(() => {
            this.isLoading = false;
        })

        PlanConsolidacion.getVigenciaPlanCons()
        .then((res) => {
            this.listVigencia = res.data.getVigencia || [];
        })
        .catch((err) => {
            console.log(err)
        })
    }
}
</script>

<style>
/* ... tus estilos tal cual los tenías ... */
.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.clickable-row:hover {
    background-color: #f8f9fa;
}

.loadingSpinner {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    justify-content: center;
    align-items: center;
}

.loadingSpinner.active {
    display: flex;
}

.custom-scroll-container {
    max-height: 600px;
    overflow-y: auto;
}

.table-responsive {
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Estilo para el tooltip en la formulación truncada */
td {
    position: relative;
}

td:hover::after {
    content: attr(title);
    position: absolute;
    left: 0;
    top: 100%;
    background: #333;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    white-space: nowrap;
    z-index: 1000;
    font-size: 12px;
}
</style>
